// import '../styles/main.scss';
import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'
import LazyLoad from 'lazyload';
// Import Swiper (full bundle: sections rely on Thumbs, Autoplay, etc. via window.Swiper)
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

if (document.querySelectorAll(".lazyload").length > 0) {
    let images = document.querySelectorAll(".lazyload");
    new LazyLoad(images);
}

// Re-scan for lazyload images added after initial load (used by customer portal modals).
window.reinitializeLazyLoad = () => {
    const images = document.querySelectorAll('.lazyload');
    if (images.length > 0) new LazyLoad(images);
};

window.Alpine = Alpine;
window.Swiper = Swiper;

document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target?.closest('.builder-v2__gift-card')) return;

    // Prevent the label default from forwarding a second click to its nested radio.
    event.preventDefault();
}, true);



import { Header } from '../components/header';
Header();

import { MiniCart } from '../components/mini-cart';
MiniCart();


Alpine.plugin(persist);
Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.start();
